import * as queryString from 'query-string'

export const gaTrack = ({
  hitType = 'event',
  eventCategory,
  eventAction,
  eventLabel = 'MarketPlace HomePage',
  hitCallback = () => undefined,
}: any) => {
  window.ga('web.send', hitType, eventCategory, eventAction, eventLabel, {
    hitCallback: () => hitCallback(),
  })
}

export const ANALYTIC_PARAMS_STORAGE_KEY = 'analytic-params'

/**
 * Returns the query string that contains the analytic params and additional params
 * Example use getAnalyticParams() or getAnalyticParams('productId=10')
 * @param {string=} additionalParams
 * @returns {string}
 */
export const getAnalyticParams = (additionalParams?: string) => {
  const analyticParams = localStorage.getItem(ANALYTIC_PARAMS_STORAGE_KEY)
  const hasAnalyticParams = analyticParams && analyticParams.length > 0

  if (!hasAnalyticParams && !additionalParams) {
    return ''
  }
  if (hasAnalyticParams && additionalParams) {
    return `${analyticParams}&${additionalParams}`
  }
  if (hasAnalyticParams) {
    return analyticParams
  }
  return `?${additionalParams}`
}

export const setAnalyticParams = (query: string) => {
  if (query && query.length > 0) {
    if (ANALYTIC_PARAMS_STORAGE_KEY in localStorage) {
      const existingQuery = queryString.parse(
        localStorage.getItem(ANALYTIC_PARAMS_STORAGE_KEY) || ''
      )
      const newQuery = queryString.parse(query)
      const newQueryStr = queryString.stringify({ ...existingQuery, ...newQuery })
      localStorage.setItem(
        ANALYTIC_PARAMS_STORAGE_KEY,
        newQueryStr.startsWith('?') ? newQueryStr : '?'.concat(newQueryStr)
      )
    } else {
      localStorage.setItem(ANALYTIC_PARAMS_STORAGE_KEY, query)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/gaTrack.ts